import MapMenu from './MapMenu'
export default MapMenu;


// WEBPACK FOOTER //
// ./src/common/components/MapMenu/index.js